(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('PackageFeatureListDeleteController', PackageFeatureListDeleteController);

    PackageFeatureListDeleteController.$inject = ['$uibModalInstance', 'entity', 'PackageFeatureList'];

    function PackageFeatureListDeleteController($uibModalInstance, entity, PackageFeatureList) {
        var vm = this;

        vm.packageFeatureList = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            PackageFeatureList.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
